import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DateTime } from "luxon";
import {
  AnalyticsCalendarInterval,
  BotOutput,
  TeamOutput,
  UserOutput,
} from "~@/graphql/codegen/generated";

type DashboardState = {
  dateStart: string | null;
  dateEnd: string | null;
  interval: Exclude<
    AnalyticsCalendarInterval,
    AnalyticsCalendarInterval.Custom
  >;
  bot: BotOutput | null;
  team: TeamOutput | null;
  operator: UserOutput | null;
};

const initialState: DashboardState = {
  dateStart: DateTime.now().minus({ days: 7 }).toISO(),
  dateEnd: DateTime.now().toISO(),
  interval: AnalyticsCalendarInterval.Day,
  bot: null,
  team: null,
  operator: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDateStart(state, action: PayloadAction<string | null>) {
      state.dateStart = action.payload;
    },
    setDateEnd(state, action: PayloadAction<string | null>) {
      state.dateEnd = action.payload;
    },
    setInterval(state, action: PayloadAction<DashboardState["interval"]>) {
      state.interval = action.payload;
    },
    setBot(state, action: PayloadAction<BotOutput | null>) {
      state.bot = action.payload;
    },
    setTeam(state, action: PayloadAction<TeamOutput | null>) {
      state.team = action.payload;
    },
    setOperator(state, action: PayloadAction<UserOutput | null>) {
      state.operator = action.payload;
    },
    // можно добавить reset action
    resetDashboard(state) {
      state.dateStart = initialState.dateStart;
      state.dateEnd = initialState.dateEnd;
      state.interval = initialState.interval;
      state.bot = null;
      state.team = null;
      state.operator = null;
    },
  },
});

export const {
  setDateStart,
  setDateEnd,
  setInterval,
  setBot,
  setTeam,
  setOperator,
  resetDashboard,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
